import React, { useEffect } from 'react';

// Attaches IntersectionObserver to all .reveal elements on the page.
const useReveal = (dep) => {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal:not(.is-visible)');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [dep]);
};

export default useReveal;
